import { render, staticRenderFns } from "./CollectionDetails.vue?vue&type=template&id=57390bf6&scoped=true"
import script from "./CollectionDetails.vue?vue&type=script&lang=js"
export * from "./CollectionDetails.vue?vue&type=script&lang=js"
import style0 from "./CollectionDetails.vue?vue&type=style&index=0&id=57390bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57390bf6",
  null
  
)

export default component.exports